export const AcademicCapIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="19" viewBox="0 0 22 19" fill="none">
      <path
        d="M8.70219 1.59475L2.52819 5.02475C1.23019 5.74575 1.23019 7.61175 2.52819 8.33275L8.70219 11.7627C10.1302 12.5557 11.8672 12.5557 13.2962 11.7627L19.4702 8.33275C20.7682 7.61175 20.7682 5.74575 19.4702 5.02475L13.2962 1.59475C11.8672 0.80175 10.1312 0.80175 8.70219 1.59475Z"
        stroke="#693EB5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.98828 9.69922V13.6232C4.98828 14.5722 5.46328 15.4572 6.25228 15.9822L7.85928 17.0512C9.76028 18.3152 12.2343 18.3152 14.1343 17.0512L15.7413 15.9822C16.5313 15.4572 17.0053 14.5712 17.0053 13.6232V9.69922"
        stroke="#693EB5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
